import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { request } from './client'

/** Раскадровка «кадр + фраза». Контракт — `backend/src/cf2/api/storyboard.py`. */
export type StoryboardStatus = 'none' | 'running' | 'ready' | 'failed'

export interface StoryboardFrame {
  /** Секунда ролика. */
  t: number
  /** Подписанная ссылка на JPEG, как у обложек. */
  image_url: string
  /** Фраза, которая звучит на этом кадре; пусто — тишина. */
  text: string
}

export interface Storyboard {
  status: StoryboardStatus
  frames: StoryboardFrame[]
  error: string | null
  created_at: string | null
  /** Ролик в кэше: без него раскадровку не построить. */
  video_cached: boolean
}

const storyboardKey = (postId: number) => ['post', postId, 'storyboard'] as const

const POLL_MS = 1500

export function useStoryboard(postId: number, enabled: boolean) {
  return useQuery({
    queryKey: storyboardKey(postId),
    queryFn: ({ signal }) => request<Storyboard>(`/api/posts/${postId}/storyboard`, { signal }),
    enabled,
    refetchInterval: (q) => (q.state.data?.status === 'running' ? POLL_MS : false),
    staleTime: 60_000,
  })
}

export function useStartStoryboard(postId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => request<Storyboard>(`/api/posts/${postId}/storyboard`, { method: 'POST' }),
    onSuccess: (data) => qc.setQueryData(storyboardKey(postId), data),
  })
}
